import type { FC } from 'react';
import InputText from '@components/InputText';
import Modal from '@components/Modal';
import { Button } from '@components/ui/button';
import { Check, Link } from 'lucide-react';

interface CopyLinkModalProps {
  audience?: string;
  isCopied: boolean;
  onClose: () => void;
  onCopy: () => void;
  url: string;
}

export const CopyLinkModal: FC<CopyLinkModalProps> = ({ audience, isCopied, onClose, onCopy, url }) => (
  <Modal
    open
    onClose={onClose}
    data-testid="copy-link-modal"
    title="Link to this contract"
    description={audience && `Anyone with access to ${audience} can access it.`}
    descriptionClassName="text-info-500!"
    className="shadow-[0px_10px_10px_-5px_rgba(0,0,0,0.04),0px_20px_25px_-5px_rgba(0,0,0,0.1)] sm:max-w-[600px]"
  >
    <div className="flex flex-col gap-6">
      <InputText readOnly tabIndex={-1} value={url} dataTestId="copy-link-url" inputClassName="bg-info-100! h-[38px]" />
      <div className="flex justify-end">
        <Button type="button" variant="primary" data-testid="copy-link-button" onClick={onCopy}>
          {isCopied ? <Check /> : <Link strokeWidth={2.5} />}
          {isCopied ? 'Link copied' : 'Copy link'}
        </Button>
      </div>
    </div>
  </Modal>
);
